import React, { Component } from 'react';
import { FormGroup, Label, Input, Col, Row, Card, CardBody, Button, Progress } from 'reactstrap';
import "../css/NumPad.css"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validarUsuario, seleccionarRol, traerServicios } from "../actions/index";
import { Redirect } from 'react-router-dom';
import MensajeModal from "../components/MensajeModal"

const mapStateToProps = state => {
    return {
        usuarioBase: state.usuarioBase,
        area: state.area
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ validarUsuario, seleccionarRol, traerServicios }, dispatch)
    };
};

class NumPad extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "ERROR",
            modalMensaje: "No se puede conectar al servicio.",
            modalFooter: "",
            selectedNumber: "",
            validacion: false,
        };
        this.devolverSelected = this.devolverSelected.bind(this);
        this.buscarUsuario = this.buscarUsuario.bind(this);
        this.solicitarConfirmacion = this.solicitarConfirmacion.bind(this);
        this.toggle = this.toggle.bind(this);
        this.datosConfirmados = this.datosConfirmados.bind(this);
    }

    solicitarConfirmacion(event) {

        var datos = this.props.usuarioBase.roles;
        //console.log(datos)
        if (datos.length === 1) {
            this.setState({
                modalTitulo: "¿Deseas confirmar?",
                modalMensaje:
                    <div>
                        <center>
                            <p>Te has identificado con la ID: {this.props.usuarioBase.identificacionUsuario} - {this.props.usuarioBase.nombreUsuario}.</p>
                            <p>¿Deseas continuar?</p>
                        </center>
                    </div>,
                modalFooter: <div>
                    <Button color="danger" onClick={this.toggle}>Cancelar</Button>{' '}
                    <Button onClick={this.datosConfirmados} key={datos[0].rol + "*-*" + datos[0].programa + "*-*" + datos[0].codigo + "*-*" + datos[0].semestre} id={datos[0].rol + "*-*" + datos[0].programa + "*-*" + datos[0].codigo + "*-*" + datos[0].semestre} color="success">Continuar</Button>
                </div>,
            })
        } else {
            var rol = this.props.usuarioBase.roles.map(p => {
                return (
                    <div key={p.rol + "*-*" + p.programa + "*-*" + p.codigo + "*-*" + p.semestre}>
                        <center>
                            <Button style={{ marginRight: "5px" }} onClick={this.datosConfirmados} key={p.rol + "*-*" + p.programa + "*-*" + p.codigo + "*-*" + p.semestre} id={p.rol + "*-*" + p.programa + "*-*" + p.codigo + "*-*" + p.semestre} color="success">{p.rol + ": " + p.programa}</Button>
                            <br />
                            <br />
                        </center>
                    </div>
                )
            });
            var x = <div>
                <center><Button color="danger" onClick={this.toggle}>Cancelar</Button><br /><br /></center>{rol}
            </div>
            this.setState({
                modalTitulo: "¿Deseas confirmar?",
                modalMensaje:
                    <div>
                        <center>
                            <p>Te has identificado con la ID: {this.props.usuarioBase.identificacionUsuario} - {this.props.usuarioBase.nombreUsuario}.</p>
                            <p>¿Con qué rol deseas continuar?</p>
                        </center>
                    </div>,
                modalFooter: x,
            })
        }
        //this.toggle();
    }


    buscarUsuario() {
        this.setState({
            modalTitulo: "Buscando",
            modalMensaje:
                <div>
                    <center>
                        <p>Estamos buscando tus datos, espera un momento por favor!</p>
                    </center>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>,
        })
        this.toggle();
        this.props.validarUsuario(this.state.selectedNumber);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.usuarioBase !== undefined) {
            setTimeout(
                function () {
                    this.solicitarConfirmacion();
                }
                    .bind(this),
                10
            );
        }
        /*if (nextProps.roles !== undefined) {
            if (nextProps.servicios !== undefined) {
                setTimeout(
                    function () {
                        this.setState({ validacion: true })
                    }
                        .bind(this),
                    10
                );
            }
        }*/
    }

    async datosConfirmados(event) {

        var datosRol = event.target.id.split("*-*");
        var jSonDatsRol = {
            rol: datosRol[0],
            programa: datosRol[1],
            codigo: datosRol[2],
            semestre: datosRol[3],
        }

        try {
            await this.props.seleccionarRol(jSonDatsRol);
            await this.props.traerServicios(datosRol[0], datosRol[2], this.props.area.idArea)
            this.setState({ validacion: true })
        } catch (error) {
            console.error(error);
        }

        /*this.props.seleccionarRol(jSonDatsRol);
        this.props.traerServicios(datosRol[0], datosRol[2], this.props.area.idArea)
        setTimeout(
            function () {
                this.setState({ validacion: true })
            }
                .bind(this),
            2000
        );*/

    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    devolverSelected(event) {
        if (event.target.id === "limpiar") {
            this.setState({
                selectedNumber: ""
            })
        } else {
            if (event.target.id === "borrar") {
                var nueva = this.state.selectedNumber;
                var colocar = nueva.slice(0, -1);
                this.setState({
                    selectedNumber: colocar
                })
            }
            else {
                if (this.state.selectedNumber.length <= 11) {
                    this.setState({
                        selectedNumber: this.state.selectedNumber + event.target.id
                    })
                }
            }
        }
    }




    render() {
        if (this.props.area.idArea === "" || this.props.area.idArea === undefined) {
            return <Redirect to={{ pathname: '/' }} />
        }
        if (this.state.validacion === true) {
            return <Redirect to={{ pathname: '/Usuario/SeleccionarServicio' }} />
        }

        var botonIngresar
        if (this.state.selectedNumber === "") {
            botonIngresar = <Button outline color="success" id="botonIngresar" disabled>Ingresar</Button>;
        }
        else {
            botonIngresar = <Button color="success" onClick={this.buscarUsuario} id="botonIngresar">Ingresar</Button>
        }

        return (
            <Col xs="12">
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>

                <Row>
                    <Col xs="1" sm="2" md="3"></Col>
                    <Col xs="10" sm="8" md="6">
                        <center>
                            <FormGroup>
                                <Label cfor="exampleEmail">Ingresa tu cédula o código</Label>
                                <Input name="email" id="exampleEmail" placeholder="" readOnly value={this.state.selectedNumber} className="text-center" />
                                {botonIngresar}
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs="1" sm="2" md="3"></Col>
                </Row>
                <Row>
                    <Col xs="1" sm="2" md="3"></Col>
                    <Col xs="10" sm="8" md="6">
                        <center>
                            <div className="panelPerso">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col xs="12">
                                                <Row>
                                                    <Col xs="4">
                                                        <div className="span4" id="1" onClick={this.devolverSelected}>
                                                            <div className="num" id="1">
                                                                <div className="txt" id="1">
                                                                    1
                            </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span4" id="2" onClick={this.devolverSelected}>
                                                            <div className="num" id="2">
                                                                <div className="txt" id="2">
                                                                    2
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span4" id="3" onClick={this.devolverSelected}>
                                                            <div className="num" id="3">
                                                                <div className="txt" id="3">
                                                                    3
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs="4">
                                                        <div className="span4" id="4" onClick={this.devolverSelected}>
                                                            <div className="num" id="4">
                                                                <div className="txt" id="4">
                                                                    4
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span4" id="5" onClick={this.devolverSelected}>
                                                            <div className="num" id="5">
                                                                <div className="txt" id="5">
                                                                    5
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span4" id="6" onClick={this.devolverSelected}>
                                                            <div className="num" id="6">
                                                                <div className="txt" id="6">
                                                                    6
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs="4">
                                                        <div className="span4" id="7" onClick={this.devolverSelected}>
                                                            <div className="num" id="7">
                                                                <div className="txt" id="7">
                                                                    7
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span4" id="8" onClick={this.devolverSelected}>
                                                            <div className="num" id="8">
                                                                <div className="txt" id="8">
                                                                    8
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span4" id="9" onClick={this.devolverSelected}>
                                                            <div className="num" id="9">
                                                                <div className="txt" id="9">
                                                                    9
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs="4">

                                                        <div className="span5" id="limpiar" onClick={this.devolverSelected}>
                                                            <div className="num" id="limpiar">
                                                                <div className="txt" id="limpiar">
                                                                    ⟲
                            </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span5" id="0" onClick={this.devolverSelected}>
                                                            <div className="num" id="0">
                                                                <div className="txt" id="0">
                                                                    0
                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs="4">
                                                        <div className="span5" id="borrar" onClick={this.devolverSelected}>
                                                            <div className="num" id="borrar">
                                                                <div className="txt" id="borrar">
                                                                    ←
                            </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>
                        </center>
                    </Col>
                    <Col xs="1" sm="2" md="3"></Col>
                </Row>
            </Col>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NumPad);
